module.exports = __webpack_public_path__ + "b5c75831be4f2cd15d09609db7e3f26b.fbx";